// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".spacer[data-v-462f93dc]{display:block;height:15px}.settings__title[data-v-462f93dc]{margin-bottom:35px}", ""]);
// Exports
module.exports = exports;
